module.exports = __webpack_public_path__ + "media/categories/2017-b92ba82f.svg";